import React, { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import InputField from "../../components/ui/InputField";
import { X } from "lucide-react";

const ModalTipoDocumento = ({ open, onClose, onSave, entity }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    obligatorio: false,
    requiereFechaExpedicion: false,
    requiereFechaVencimiento: false,
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    setFormData({
      nombre: entity?.nombre || "",
      obligatorio: !!entity?.obligatorio,
      requiereFechaExpedicion: !!entity?.requiereFechaExpedicion,
      requiereFechaVencimiento: !!entity?.requiereFechaVencimiento,
    });
  }, [open, entity]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      await onSave(formData); // 🔥 IMPORTANTE: esperar
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 p-2 sm:p-4">
      <div className="w-full max-w-2xl h-[95vh] sm:h-auto sm:max-h-[90vh] bg-white rounded-t-2xl sm:rounded-2xl shadow-lg flex flex-col">
        {/* HEADER */}
        <div className="relative px-6 py-4 border-b flex-shrink-0">
          <h2 className="text-lg font-bold">
            {entity ? "Editar tipo de documento" : "Nuevo tipo de documento"}
          </h2>
          <button
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
            onClick={onClose}
            disabled={isLoading}
          >
            <X />
          </button>
        </div>

        {/* BODY */}
        <form
          onSubmit={handleSubmit}
          className="flex-1 overflow-y-auto p-6 space-y-4"
        >
          <InputField
            label="Nombre *"
            name="nombre"
            value={formData.nombre}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, nombre: e.target.value }))
            }
            placeholder="Ej. Registro sanitario"
            required
            disabled={isLoading}
          />

          <label className="flex items-center gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={formData.obligatorio}
              disabled={isLoading}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  obligatorio: e.target.checked,
                }))
              }
            />
            Documento obligatorio
          </label>

          <label className="flex items-center gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={formData.requiereFechaExpedicion}
              disabled={isLoading}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  requiereFechaExpedicion: e.target.checked,
                }))
              }
            />
            Requiere fecha de expedición
          </label>

          <label className="flex items-center gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={formData.requiereFechaVencimiento}
              disabled={isLoading}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  requiereFechaVencimiento: e.target.checked,
                }))
              }
            />
            Requiere fecha de vencimiento
          </label>
        </form>

        {/* FOOTER */}
        <div className="p-4 sm:p-6 border-t flex flex-col sm:flex-row justify-end gap-2 flex-shrink-0">
          <Button
            type="button"
            className="bg-red-500 hover:bg-red-600 text-white"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </Button>

          <Button type="submit" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? "Guardando..." : "Guardar"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalTipoDocumento;
